import { combineReducers } from 'redux';
import {
  INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON,
  INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON,
  INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE,
  INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
  INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE,
  INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
  INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
  INGREDIENT_SUBSCRIPTION_SET_OUTLETS,
  INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
  INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
} from 'actions/ingredients/ingredientSubscription/constant';
import createReducer from 'utils/createReducer';

const featurePrice = createReducer(
  {},
  {
    [INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE]: (draft, { payload }) =>
      payload.featurePrice,
  }
);

const featurePricePerMonths = createReducer(0, {
  [INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS]: (
    draft,
    { payload }
  ) => payload.featurePricePerMonths,
});

// FIXME wrong default type
const isOnTutorial = createReducer(null, {
  [INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL]: (draft, { payload }) =>
    payload.isOnTutorial,
});

// FIXME wrong default type
const pendingPaymentMessage = createReducer(null, {
  [INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE]: (draft, { payload }) =>
    payload.pendingPaymentMessage,
});

// FIXME wrong default type
const pendingOutletMessage = createReducer(null, {
  [INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE]: (draft, { payload }) =>
    payload.pendingOutletMessage,
});

// FIXME negative boolean
const isButtonDisabled = createReducer(false, {
  [INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON]: () => false,
  [INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON]: () => true,
});

// FIXME feels like UI concern
const buttonMessage = createReducer('Pay', {
  [INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE]: (draft, { payload }) =>
    payload.buttonMessage,
});

const subscriptionDetail = createReducer(
  {},
  {
    [INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL]: (draft, { payload }) =>
      payload.subscriptionDetail,
  }
);

const pageOnLoading = createReducer(true, {
  [INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE]: () => false,
});

const currentOutletCount = createReducer(0, {
  [INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT]: (draft, { payload }) =>
    payload.currentOutletCount,
});

const showDetailModal = createReducer(false, {
  [INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL]: () => true,
  [INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL]: () => false,
});

const outletList = createReducer([], {
  [INGREDIENT_SUBSCRIPTION_SET_OUTLETS]: (draft, { payload }) =>
    payload.outlets,
});

const showPaymentGatewayErrorModal = createReducer(false, {
  [INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL]: () => true,
  [INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL]: () => false,
});

export default combineReducers({
  featurePrice,
  featurePricePerMonths,
  isOnTutorial,
  pendingPaymentMessage,
  pendingOutletMessage,
  isButtonDisabled,
  buttonMessage,
  subscriptionDetail,
  pageOnLoading,
  currentOutletCount,
  showDetailModal,
  outletList,
  showPaymentGatewayErrorModal,
});
